import { CanActivateFn, Router } from '@angular/router';
import { paths } from '../pages/paths';
import { PageStatusService } from '@services/page-status.service';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, filter, map } from 'rxjs';
import { AuthService } from '@services/auth.service';

export const pageGuard: CanActivateFn = (route, state) => {
  const path = `/${route.url[0]?.path || ''}`;
  const page = paths.find((p) => p.path === path);
  const role$ = inject(AuthService).role$;
  const router = inject(Router);
  const pagesSih = inject(PageStatusService).pages.value;
  return combineLatest({ pages: toObservable(pagesSih), role: role$ }).pipe(
    filter(({ pages }) => !!pages && pages.length > 0),
    map(({ pages, role }) => {
      const pageStatus = pages!.find((p) => p.path === path);
      if (pageStatus?.status == 'hidden') {
        console.warn(`Page "${path}" is hidden.`);
        const firstPublicPage = pages!.find((p) => p.status === 'public');
        return router.parseUrl(firstPublicPage?.path || '/');
      }
      if (pageStatus?.status == 'admin' && role !== 'admin') {
        return router.parseUrl('/coming-soon');
      }
      if (pageStatus?.status == 'guest' && role !== 'guest' && role !== 'admin') {
        return router.parseUrl('/login');
      }
      return true;
    }),
  );
};
